<div id="tabChildrenUp18Data" [formGroup]="form" *ngIf="childrenItems && childrenItems.controls.length != 0">
    <div class="row" >
        <div class="col-md-12 col-xs-12 group"> 
            <div formArrayName="childrenItems" *ngFor="let item of childrenItems.controls; let i = index;">
                <div  [formGroupName]="i" *ngIf="f2[i]">               
                    <div class="row">
                        <div class="col-md-12 col-xs-12 group-title">
                            <h5>מילוי נתונים אישיים</h5>
                        </div>
                    </div>
                    <personal-info [form]="f2[i]" [isSocialID_Mandarory]="isSocialID_Mandarory[i]" relation= "ילד"></personal-info>
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <yes-no [form]="f2[i]" controlName="borne_israel" 
                                    text="האם נולדת בישראל?">
                            </yes-no> 
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-xs-12">
                            <israely-status [form]="f2[i]" isForChild="true" (statChanged)="checkIsraelyStatus($event, i)">

                            </israely-status>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-xs-12">
                            <div class="row">
                                    <div class="col-md-12 col-xs-12">
                                        <yes-no [form]="f2[i]" controlName="moia_donation" 
                                                text="קיבלתי בעבר סיוע כעולה ממשרד העלייה והקליטה">
                                        </yes-no> 
                                    </div>
                            </div>
                            <div class="row">
                                    <div class="col-md-12 col-xs-12">
                                        <yes-no [form]="f2[i]" controlName="returning_donation" 
                                                text="קיבלתי בעבר סיוע כתושב חוזר ממשרד העלייה והקליטה">
                                        </yes-no> 
                                    </div>
                            </div>
                            <br>
                        </div>                        
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</div>